import type { StateWorkspaceSummary } from '@/lib/apiTypes'
import { Tooltip } from '@/shared/components/Tooltip'
import { WorkspaceRow } from '@/features/state/components/WorkspaceRow'

export function WorkspacesTable({ orgId, token, workspaces, onOpen, onRefresh }: {
  orgId: string
  token: string | null
  workspaces: StateWorkspaceSummary[]
  onOpen: (ws: StateWorkspaceSummary) => void
  onRefresh: () => void
}) {
  return (
    <div className="table-wrap fu">
      <table>
        <thead>
          <tr>
            <th>
              <Tooltip text="Workspace name, plus any state lock or serve override. Click a row to open it." placement="top">
                <span tabIndex={0} className="cursor-help">Workspace</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="Serial of the newest state version - the one every other column on this row describes. Terraform assigns it, incrementing on each apply. Open the workspace to browse the full version history." placement="top">
                <span tabIndex={0} className="cursor-help">Latest serial</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="Resources in the latest state version, split into real and internal." placement="top">
                <span tabIndex={0} className="cursor-help">Resources</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="State of the latest version’s security scan." placement="top">
                <span tabIndex={0} className="cursor-help">Scan</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="Critical (C) and high (H) vulnerability counts from the latest version's completed scan - never an older version's. Open the workspace for the per-version breakdown." placement="top">
                <span tabIndex={0} className="cursor-help">Findings</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="How many org policies this workspace currently fails." placement="top">
                <span tabIndex={0} className="cursor-help">Policy</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="Who or what pushed the latest state version." placement="top">
                <span tabIndex={0} className="cursor-help">Pushed by</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="When the latest state version was pushed. Hover for the exact time." placement="top">
                <span tabIndex={0} className="cursor-help">Pushed at</span>
              </Tooltip>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {workspaces.map((ws) => (
            <WorkspaceRow
              key={ws.id}
              orgId={orgId}
              token={token}
              ws={ws}
              onOpen={() => onOpen(ws)}
              onRefresh={onRefresh}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

